import React, { Component } from 'react';
import { Redirect, withRouter, Link } from 'react-router-dom';

import { request, reportErrorToHoneybadger } from '../../helpers/Requests'

import ViewEvent from '../../components/exports/ViewEvent';
import { arrayParamBuilder, listWithGrammar, formatDate, renderSortColumn, datify } from '../../utilities/Generic.js'
import { renderCheckOutWithContext } from '../../utilities/Events.js'
import NoticeBox from '../../components/shared/NoticeBox';

import CsvDownloader from 'react-csv-downloader';

import { faFileDownload } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import SlidingPane from "../../components/shared/ScrollableSlidingPane";

class ExportVisitors extends Component {
  constructor(props) {
    super(props);

    this.handleEventPanel = this.handleEventPanel.bind(this);
    this.renderSortColumn = renderSortColumn.bind(this);
  }

  emptyVisitors(events) {
    if (events.length === 0) {
      return (
        <div className="long-tr">
          <div className="long-td">
            { this.emptyVisitorsText() }
          </div>
        </div>
      )
    }
  }

  emptyVisitorsText() {
    let text = "No visitors to show"

    if (this.props.page > 1) {
      text += " on this page"
    }

    let content = []
    this.props.selected_location !== "" && content.push(" Location")
    this.props.visited_type_of_person !== "" && content.push(" Visited Type")
    this.props.visitor_type_of_person !== "" && content.push(" Visitor Type")

    if (content.length > 0) {
      text += ` for this ${listWithGrammar(content)}`
    }

    let tags = []
    this.props.visited_tag_ids.length !== 0 && tags.push(" Visited Tags")
    this.props.visitor_tag_ids.length !== 0 && tags.push(" Visitor Tags")

    if (tags.length > 0) {
      text += ` with these ${listWithGrammar(tags)}`
    }

    let search = []
    this.props.visited_person_search.length !== 0 && search.push(" Visited Name Search")
    this.props.visitor_person_search.length !== 0 && search.push(" Visitor Name Search")

    if (search.length > 0) {
      text += ` using this ${listWithGrammar(search)}`
    }

    text += " in this time range."

    return text
  }

  customAttributeFinder(custom_attribute_id){
    return this.props.custom_attributes.find(custom_attribute => custom_attribute.id === custom_attribute_id)
  }

  personCustomAttributeFinder(person, custom_attribute_id){
    // returns empty object if person custom attribute is not available
    return person.custom_attributes.find(custom_attribute => custom_attribute.custom_attribute_id === custom_attribute_id) || {}
  }

  renderCustomAttributeHeaders() {
    let activeCustomAttributes = []

    this.props.custom_attribute_ids.forEach((custom_attribute_id) =>
      activeCustomAttributes.push(this.customAttributeFinder(custom_attribute_id))
    )

    return (
      <React.Fragment>
        {activeCustomAttributes.map((custom_attribute, index) => (
          <div className="th" key={"custom_attribute"+index}>{custom_attribute.name}</div>
        ))}
      </React.Fragment>
    )
  }

  renderPersonCustomAttributes(person) {
    return (
      <>
        {this.props.custom_attribute_ids.map((custom_attribute_id, index) => {
          const custom_attribute = this.personCustomAttributeFinder(person, custom_attribute_id)
          return (
            <div className="td" key={"custom_attribute"+index}>{custom_attribute.value}</div>
          )
        })}
      </>
    )
  }

  customAttributeCSV() {
    let array = []
    this.props.custom_attribute_ids.forEach((custom_attribute_id) => {
      const custom_attribute = this.customAttributeFinder(custom_attribute_id)

      array.push({ displayname: custom_attribute.name, id: custom_attribute.id.toString()})
    })
    return array
  }

  downloadCSV(events) {
    let filename = `visitors-export-${formatDate(new Date(), 0)}.csv`

    let columns = [
      { displayname: "Visited Name", id: "visited_person_name" },
      { displayname: "Visited Type", id: "visited_type_of_person" },
      { displayname: "Visitor Name", id: "visitor_person_name" },
      { displayname: "Visitor Type", id: "visitor_type_of_person" },
      { displayname: "Arrived", id: "check_in" },
      { displayname: "Left", id: "check_out" },
      { displayname: "Location", id: "location" }
    ];

    if (this.props.showDuration) {
      columns.splice(4, 0, { displayname: "Duration (hours)", id: "duration"})
    }

    columns = columns.concat(this.customAttributeCSV())

    return (
      <CsvDownloader datas={() => this.getCSVData(events, columns)} columns={columns} filename={filename} className="edit-button download-csv" wrapColumnChar='"'>
        <div>
          <FontAwesomeIcon icon={faFileDownload} />
          <h4>{this.state.CSVDataLoading ? "Downloading additional data..." : "Download CSV"}</h4>
        </div>
      </CsvDownloader>
    )
  }

  async getCSVData(currentPageData, columns) {
    this.setState({ CSVDataLoading: true })
    let events = await this.recursivePageGrab(currentPageData)

    // mapping custom attributes back into people using the custom_attribute_id as a key to match the keys in customAttributeCSV()
    events.forEach((event) => {
      event.custom_attributes.forEach((custom_attribute) => {
        event[custom_attribute.custom_attribute_id.toString()] = custom_attribute.value
      })
    })

    if (events.length === 0) {
      events = [{[columns[0].id]: this.emptyVisitorsText()}]
    }
    this.setState({ CSVDataLoading: false })

    return events
  }

  async recursivePageGrab(currentPageData, previousData = [], page = 1, previousVisitors = false, previousCoolVisitors = false) {
    const [newData, moreRecursionRequired, newVisitors, newCoolVisitors] = page === parseInt(this.props.page) ? [currentPageData, this.state.visitors.length === 250 || this.state.cool_visitors_paginated, this.state.visitors.length > 0, this.state.cool_visitors.length > 0] : await this.grabData(page)
    const data = previousData.concat(newData)
    const visitorsPresent = previousVisitors || newVisitors
    const coolVisitorsPresent = previousCoolVisitors || newCoolVisitors

    return moreRecursionRequired ? this.recursivePageGrab(currentPageData, data, page + 1, visitorsPresent, coolVisitorsPresent) : this.sortedData(data, visitorsPresent, coolVisitorsPresent)
  }

  async grabData(page) {
    let modifiedDateFrom = new Date(this.props.date_from)
    modifiedDateFrom.setMonth(modifiedDateFrom.getMonth() + 3)
    modifiedDateFrom.setDate(modifiedDateFrom.getDate() - 3)

    let modifiedDateTo = new Date(this.props.date_to)
    modifiedDateTo.setMonth(modifiedDateTo.getMonth() + 3)
    modifiedDateTo.setDate(modifiedDateTo.getDate() + 3)

    const dateFromPastThreeMonths = modifiedDateFrom < Date.now();
    const dateToPastThreeMonths = modifiedDateTo < Date.now();

    let params = `visitors[date_from]=${this.props.date_from}&visitors[date_to]=${this.props.date_to}&visitors[location]=${this.props.selected_location}&visitors[visited_person]=${this.props.visited_type_of_person}&visitors[visitor_person]=${this.props.visitor_type_of_person}${arrayParamBuilder("visitors", "visited_tag_ids", this.props.visited_tag_ids)}${arrayParamBuilder("visitors", "visitor_tag_ids", this.props.visitor_tag_ids)}${arrayParamBuilder("visitors", "custom_attribute_ids", this.props.custom_attribute_ids)}&visitors[visited_person_search]=${this.props.visited_person_search}&visitors[visitor_person_search]=${this.props.visitor_person_search}&page=${page}&sort=${this.props.sort}&direction=${this.props.direction}`

    let grabbed_cool_visitors = []
    let grabbed_visitors = []
    let grabbed_cool_visitors_paginated = false

    const cool_visitors_promise = dateFromPastThreeMonths && request('GET', `/v1/a/exports/cool_visitors?${params}`, null, () => {this.setState({ unauthorized: true })}).then(data => {grabbed_cool_visitors = data.visited_people || []; grabbed_cool_visitors_paginated = data.further_page})
    const visitors_promise = !dateToPastThreeMonths && request("GET", `/v1/a/exports/visitors?${params}`, null, () => {this.setState({ unauthorized: true })}).then(data => grabbed_visitors = data)

    await Promise.all([cool_visitors_promise, visitors_promise])

    let allVisitors = grabbed_visitors.concat(grabbed_cool_visitors)

    return [allVisitors, grabbed_visitors.length === 250 || grabbed_cool_visitors_paginated, grabbed_visitors.length > 0, grabbed_cool_visitors.length > 0]
  }

  handleEventPanel(event) {
    let id = event.currentTarget.id;

    this.setState({
      eventId: id,
      eventPanelToggle: true,
      previousURL: `${this.props.location.pathname}${this.props.location.search}`
    });
    this.props.history.push(`/exports/events/${id}`)
  }

  renderPageButtons(page, records, cool_visitors_paginated) {
    if (parseInt(page) === 1 && records.length < 250 && cool_visitors_paginated === false) {
      return
    }
    else {
      return (
        <div>
          <button className="button new-button" onClick={this.props.handleNextPage} disabled={(records.length < 250 && cool_visitors_paginated === false)}>Next Page</button>
          <button className="button new-button" onClick={this.props.handlePreviousPage} disabled={(this.props.page < 2)}>Previous Page</button>
        </div>
      )
    }
  }

  renderCoolVisitorsPaginationInfo(page, cool_visitors_paginated, sort) {
    let modifiedDateFrom = new Date(this.props.date_from)
    modifiedDateFrom.setMonth(modifiedDateFrom.getMonth() + 3)
    modifiedDateFrom.setDate(modifiedDateFrom.getDate() - 3)

    const dateFromPastThreeMonths = modifiedDateFrom < Date.now();

    if (dateFromPastThreeMonths && (page !== 1 || cool_visitors_paginated) && ["visited_person", "visited_type_of_person"].includes(sort)) {
      return (
        <div className="big-top-padding">
          <NoticeBox type="info" text="Some Visitors from over 3 months old that you may expect to see given your current sort may not currently be visible. If you can't find what you are looking for, please try narrowing your search parameters, or try looking on other pages." />
        </div>
      )
    }
  }

  renderVisitorRow(visit) {
    return (
      <Link to={`/exports/visitors/${visit.event_id}`} onClick={this.handleEventPanel} id={visit.event_id} key={visit.id} className="tr event">
        <div className="td">{visit.visited_person_name}</div>
        <div className="td">{visit.visited_type_of_person}</div>
        <div className="td">{visit.visitor_person_name}</div>
        <div className="td">{visit.visitor_type_of_person}</div>
        <div className="td">{visit.check_in}</div>
        { renderCheckOutWithContext(visit) }
        { this.props.showDuration && <div className="td">{visit.duration}</div>}
        <div className="td">{visit.location}</div>
        {this.renderPersonCustomAttributes(visit)}
      </Link>
    )
  }

  sortedData(visitors, visitorsPresent, coolVisitorsPresent) {
    if ((visitorsPresent && coolVisitorsPresent) || (coolVisitorsPresent && ["visited_person", "visited_type_of_person"].includes(this.props.sort))) {
      if (this.props.direction === "asc") {
        visitors = visitors.sort((firstEntry, secondEntry) => this.determineOrder(firstEntry, secondEntry));
      }
      else if (this.props.direction === "desc") {
        visitors = visitors.sort((firstEntry, secondEntry) => this.determineOrder(secondEntry, firstEntry));
      }
    }

    return visitors
  }

  determineOrder(firstEntry, secondEntry) {
    if (this.props.sort === "default") {
      return 0
    }

    if (["check_in", "check_out"].includes(this.props.sort)) {
      return datify(firstEntry[this.props.sort]) - datify(secondEntry[this.props.sort])
    }

    let sort_by = (this.props.sort === "visited_person" || this.props.sort === "visitor_person") ? this.props.sort + "_name" : this.props.sort

    let [parsedFirstEntry, parsedSecondEntry] = [firstEntry[sort_by], secondEntry[sort_by]];

    if (parsedFirstEntry > parsedSecondEntry) {
      return 1
    }

    if (parsedSecondEntry > parsedFirstEntry) {
      return -1
    }

    return 0
  }

  render() {
    const { visitors, cool_visitors, visitorsLoaded, coolVisitorsLoaded, error, unauthorized, invalid_params, cool_visitors_paginated } = this.state;

    if (unauthorized) {
      return <Redirect to="/login"/>
    }

    if (error) {
      return <div>{error.message}</div>;
    }

    if (invalid_params === true) {
      return <p>Waiting for valid date range ...</p>;
    }

    if (visitorsLoaded === false || coolVisitorsLoaded === false) {
      return <p>Loading ...</p>;
    }

    if (visitorsLoaded && coolVisitorsLoaded) {
      let allVisitors = this.sortedData(visitors.concat(cool_visitors), visitors.length > 0, cool_visitors.length > 0)

      return (
        <div className="relative">
          {this.downloadCSV(allVisitors)}

          <div className="table big-table top-padding" data-testid="table">
            <div className="tr heading">
              {this.renderSortColumn("Visited Name", "visited_person")}
              {this.renderSortColumn("Visited Type", "visited_type_of_person")}
              {this.renderSortColumn("Visitor Name", "visitor_person")}
              {this.renderSortColumn("Visitor Type", "visitor_type_of_person")}
              {this.renderSortColumn("Arrived", "check_in")}
              {this.renderSortColumn("Left", "check_out")}
              { this.props.showDuration && <div className="th">Duration (hours)</div> }
              {this.renderSortColumn("Location", "location")}
              {this.renderCustomAttributeHeaders()}
            </div>

            {allVisitors.map(visit => this.renderVisitorRow(visit))}
          </div>

          {this.emptyVisitors(allVisitors)}
          {this.renderPageButtons(this.props.page, visitors, cool_visitors_paginated)}
          {this.renderCoolVisitorsPaginationInfo(this.props.page, cool_visitors_paginated, this.props.sort)}

          <SlidingPane isOpen={this.state.eventPanelToggle} title="View Event" width="60%"
            onRequestClose={() => {
              this.setState({ eventPanelToggle: false });
              this.setState({ eventId: null });
              this.props.history.push(this.state.previousURL);
              this.componentDidMount();
            }}>
            <ViewEvent id={this.state.eventId} />
          </SlidingPane>
        </div>
      );
    }
  }

  state = {
    visitors: [],
    cool_visitors: [],
    cool_visitors_paginated: false,
    error: null,
    unauthorized: null,
    invalid_params: false,

    visitorsLoaded: false,
    coolVisitorsLoaded: false,

    eventId: null,
    eventPanelToggle: false,
    previousURL: "/exports/visitors"
  };

  static getDerivedStateFromProps(props, state) {
    if (props.history.action === "POP" && props.id !== undefined) {
      return {
        eventPanelToggle: true,
        eventId: props.id
      }
    }
    else {
      return null
    }
  }

  componentDidMount() {
    // deep linking
    if (this.props.id !== undefined && this.state.eventPanelToggle === false) {
      this.setState({
        eventId: this.props.id,
        eventPanelToggle: true
      });
    }

    if (this.props.date_from !== "" && this.props.date_to !== "") {
      let modifiedDateFrom = new Date(this.props.date_from)
      modifiedDateFrom.setMonth(modifiedDateFrom.getMonth() + 3)
      modifiedDateFrom.setDate(modifiedDateFrom.getDate() - 3)

      let modifiedDateTo = new Date(this.props.date_to)
      modifiedDateTo.setMonth(modifiedDateTo.getMonth() + 3)
      modifiedDateTo.setDate(modifiedDateTo.getDate() + 3)

      const dateFromPastThreeMonths = modifiedDateFrom < Date.now();
      const dateToPastThreeMonths = modifiedDateTo < Date.now();

      let params = `visitors[date_from]=${this.props.date_from}&visitors[date_to]=${this.props.date_to}&visitors[location]=${this.props.selected_location}&visitors[visited_person]=${this.props.visited_type_of_person}&visitors[visitor_person]=${this.props.visitor_type_of_person}${arrayParamBuilder("visitors", "visited_tag_ids", this.props.visited_tag_ids)}${arrayParamBuilder("visitors", "visitor_tag_ids", this.props.visitor_tag_ids)}${arrayParamBuilder("visitors", "custom_attribute_ids", this.props.custom_attribute_ids)}&visitors[visited_person_search]=${this.props.visited_person_search}&visitors[visitor_person_search]=${this.props.visitor_person_search}&page=${this.props.page}&sort=${this.props.sort}&direction=${this.props.direction}`

      if (dateFromPastThreeMonths) {
        request('GET', `/v1/a/exports/cool_visitors?${params}`, null, () => {this.setState({ unauthorized: true })})
          .then(data => {
            this.setState({ cool_visitors: data.visited_people || [], cool_visitors_paginated: data.further_page, coolVisitorsLoaded: true })
          })
          .catch(error => {
            reportErrorToHoneybadger(error)

            this.setState({ error, coolVisitorsLoaded: true })
          })
      }

      if (dateToPastThreeMonths === false) {
        request('GET', `/v1/a/exports/visitors?${params}`, null, () => {this.setState({ unauthorized: true })})
          .then(data => {
            this.setState({ visitors: data, visitorsLoaded: true })
          })
          .catch(error => {
            reportErrorToHoneybadger(error)

            this.setState({ error, visitorsLoaded: true })
          })
      }

      if (dateToPastThreeMonths) {
        // Visitors call has not triggered. Manually set the state and continue with just CoolVisitors
        this.setState({ visitors: [], visitorsLoaded: true })
      }

      if (dateFromPastThreeMonths === false) {
        // CoolVisitors call has not triggered. Manually set the state and continue with just Visitors
        this.setState({ cool_visitors: [], cool_visitors_paginated: false, coolVisitorsLoaded: true })
      }
    }
    else {
      this.setState({
        invalid_params: true
      })
    }
  }
}

export default withRouter(ExportVisitors);
